import { Container } from "../../components/atoms/container/Container";
import style from "./ticketHandling.module.scss";
import { Text } from "../../components/atoms/text/Text";
import { Button } from "../../components/atoms/button/Button";
import { EmergencyCheck } from "../../components/organisms/emergencyCheck/EmergencyCheck";
import { SelectPatient } from "../../components/organisms/selectPatient/SelectPatient";
import { MedicalCondition } from "../../components/organisms/medicalCondition/MedicalCondition";
import { PatientCondition } from "../../components/organisms/patientCondition/PatientCondition";
// import { SelectAssistance } from "../../components/organisms/selectAssistance/SelectAssistance";
import { TicketBasicDetWrapper } from "../../components/organisms/ticketBasicDetWrapper/TicketBasicDetWrapper";
import { useFetchTicket } from "../../hooks/useFetchTicket/UseFetchTicket";
import { SelectPoc } from "../../components/organisms/selectPoc/SelectPoc";
import { ConditionalWrapper } from "../../components/organisms/conditionalWrapper/ConditionalWrapper";
import { EmergencyCheckWrapper } from "../../components/organisms/emergencyCheckWrapper/EmergencyCheckWrapper";
import withNavigation from "../../components/molecules/ticketWrapper/TicketWrapper";
import useTicketNavigation from "../../hooks/useTicketNavigation/useTicketNavigation";
import { useEffect, useRef } from "react";

export const TicketHandlingPart = () => {
  const emergencyCheckRef = useRef<HTMLDivElement>(null);
  const selectPatientRef = useRef<HTMLDivElement>(null);
  const selectPocRef = useRef<HTMLDivElement>(null);
  const medicalConditionRef = useRef<HTMLDivElement>(null);
  const patientConditionRef = useRef<HTMLDivElement>(null);
  
  //eslint-disable-next-line
  const { isLoading, isError, data, handleSaveAssessment, getTicketUpdateData } = useFetchTicket();

  const handleRedirect = useTicketNavigation();
  
  const scrollToSection = (ref: React.RefObject<HTMLDivElement>) => {
    ref.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };
  
  const handleSaveWithScroll = async () => {
    const { currentMedicalStatusResponse, patient, poc } = getTicketUpdateData || {};
    
    if (!currentMedicalStatusResponse?.isItEmergency) {
      scrollToSection(emergencyCheckRef);
      await handleSaveAssessment();
      return;
    }
    if (!patient) {
      scrollToSection(selectPatientRef);
      await handleSaveAssessment();
      return;
    }
    if (!poc?.fullName || !poc?.mobile || poc?.mobile?.length !== 10) {
      scrollToSection(selectPocRef);
      await handleSaveAssessment();
      return;
    }
    if (
      !currentMedicalStatusResponse?.isAmbulanceRequired ||
      !currentMedicalStatusResponse?.isDoctorConsultationRequired ||
      !currentMedicalStatusResponse?.isPatientConscious
    ) {
      scrollToSection(patientConditionRef);
      await handleSaveAssessment();
      return;
    }
    if (!currentMedicalStatusResponse?.mobilityStatus) {
      scrollToSection(medicalConditionRef);
      await handleSaveAssessment();
      return;
    }
    if (!currentMedicalStatusResponse?.currentCondition?.length) {
      scrollToSection(medicalConditionRef);
      await handleSaveAssessment();
      return;
    }
    
    await handleSaveAssessment();
  };
  
  useEffect(() => {
    if (data) {
      handleRedirect(data);
    }
  }, [data, handleRedirect]);
  return (

      <TicketBasicDetWrapper>
        <Container className={style.wrapper}>
          <Text className={style.heading} text="Assessment" />
          <div className={style.border}></div>
          <Container className={style.container}>
            <Container className={style.assessment_container}>
              <Container className={style.step}>
                <Button text="Completed :1/3" className={style.step_button} />
              </Container>
              <Container className={style.emHandle} ref={emergencyCheckRef}>
                <EmergencyCheck ticketData={data} />
              </Container>
              <EmergencyCheckWrapper ticketData={getTicketUpdateData}>
                <Container className={style.emHandle} ref={selectPatientRef}>
                  <SelectPatient />
                </Container>
                <Container className={style.emHandle} ref={selectPocRef}>
                  <SelectPoc />
                </Container>
                <Container className={style.emHandle} ref={medicalConditionRef}>
                  <MedicalCondition />
                </Container>
                <ConditionalWrapper ticketUpdateData={getTicketUpdateData}>
                <Container className={style.emHandle} ref={patientConditionRef}>
                  <PatientCondition />
                </Container>
                {!(
                  getTicketUpdateData?.currentMedicalStatusResponse?.isAmbulanceRequired === "No" &&
                  getTicketUpdateData?.currentMedicalStatusResponse?.isDoctorConsultationRequired === "No"
                ) && (
                    <Container className={style.button_assignment}>
                      <Button
                        text={getTicketUpdateData?.currentMedicalStatusResponse.isAmbulanceRequired === "No" ? "Start Emergency" : "Save Assessment"}
                        className={style.button}
                        onClick={handleSaveWithScroll}
                      />
                    </Container>
                  )}
              </ConditionalWrapper>
              </EmergencyCheckWrapper>
            </Container>
          </Container>
        </Container>
      </TicketBasicDetWrapper>
    
  );
};

const TicketHandlingPart1 = withNavigation(TicketHandlingPart);
export default TicketHandlingPart1;